import { get } from 'miniruche/services/api';

export function fetchAdminMiniruche(payload) {
    const miniRucheRequest = get(`miniruche/admin/${payload.slug}`);
    const assembliesRequest = get(`miniruche/admin/${payload.slug}/assemblies`);

    return Promise.all([miniRucheRequest, assembliesRequest]);
}
